import { Plural, Trans } from "@lingui/react/macro";
import React from "react";
import * as styles from "./CourtesyHoldEcommerceBenefits.module.scss";
import { Icon } from "@silversea-ssc/ui-components-react";
import { ABTestDomAttr } from "src/ab-test-experiments/client/use-experiment-tag";
import { ECommerceStatus } from "src/ssc-api/useECommerceStatus";
import { NewEcommerceButton } from "components/ECommerceButtons";

type CourtesyHoldEcommerceBenefitsProps = {
  days: number;
  ecommerceStatus: ECommerceStatus | undefined;
} & Partial<ABTestDomAttr>;

const CourtesyHoldEcommerceBenefits: React.FC<
  CourtesyHoldEcommerceBenefitsProps
> = ({ days: daysCount, ecommerceStatus, ...abTestDom }) => {
  const days = (
    <span className={styles.days}>
      <Plural value={daysCount || 0} one="# DAY" other="# DAYS" />
    </span>
  );

  return (
    <div
      className={styles.box}
      data-content-name="courtesy_hold_banner"
      {...abTestDom}
    >
      <div className={styles.badge}>
        <Icon
          name="circle-check"
          wrapperClassName={styles.badgeIcon}
          padding={false}
        />{" "}
        <Trans id="courtesy-hold-banner-badge">
          Free of charge - price blocked
        </Trans>
      </div>
      <div className={styles.contentContainer}>
        <div className={styles.title}>
          {" "}
          <Trans id="courtesy-hold-banner-title">Courtesy hold available</Trans>
        </div>
        <div className={styles.content}>
          <Trans id="courtesy-hold-banner-content">
            Select your suite, we’ll keep it on hold for you and block the price
            for {days}.
          </Trans>
        </div>
        <div className={styles.button}>
          {ecommerceStatus && (
            <NewEcommerceButton
              variant="secondary"
              size="small"
              raqUrl={undefined}
              ecommerceStatus={ecommerceStatus}
              disableRAQ
              overrideEcommerceLabel={<Trans>Keep my suite on hold</Trans>}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default CourtesyHoldEcommerceBenefits;
